import { logg } from './util/logg';

const cname = 'lyoc_cookie';

// TODO should be 2 cookies, one for site auth, another that exists per game,
// generated when lobby is joined

// Auth needs to contain player's DB id

export default function getLyocCookie() {
	const name = cname + '=';
	const decodedCookie = decodeURIComponent(document.cookie) || null;
	if (decodedCookie == null) {
		return null;
	}
	const ca = decodedCookie.split(';');
	for (let i = 0; i < ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) === ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) === 0) {
			// logg(c.substring(name.length, c.length));
			return c.substring(name.length, c.length);
		}
	}
	return null;
}

export function setLyocCookie(cvalue: string, exdays = 3) {
	const d = new Date();
	d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
	const expires = 'expires=' + d.toUTCString();
	document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
}

export function eraseLyocCookie() {
	logg('eraseLyocCookie');
	const cvalue = getLyocCookie();

	const d = new Date();
	d.setTime(d.getTime() - 3 * 24 * 60 * 60 * 1000);
	const expires = 'expires=' + d.toUTCString();
	document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
	logg(document.cookie);
}
